// extracted by mini-css-extract-plugin
export default {"page":"admin_page__mZgWC","main":"admin_main__as+yC","tabs":"admin_tabs__3NVDL"};